import cn from 'classnames';
import styles from './field.module.scss';


type ComponentProps = {
    className?: string;
};


export const FieldRequiredMark = ({ className }: ComponentProps) => {
    return (
        <span className={ cn(styles.required_mark, className) }>
            *
        </span>
    );
};
